module.exports = __webpack_public_path__ + "img/ziyuan.eb262580.png";